var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBell(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0H32V32H0z",
    transform: "translate(-1800 -424) translate(1688 424) translate(112)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    d: "M22.545 18.184V12.73c0-3.616-2.93-6.547-6.545-6.547-3.615 0-6.545 2.931-6.545 6.547v5.455c0 .795-.213 1.54-.584 2.182h14.258c-.371-.642-.584-1.387-.584-2.182zm4.364 4.364H5.091c-1.455 0-1.455-2.182 0-2.182 1.205 0 2.182-.977 2.182-2.182V12.73C7.273 7.908 11.18 4 16 4s8.727 3.908 8.727 8.729v5.455c0 1.205.977 2.182 2.182 2.182 1.455 0 1.455 2.182 0 2.182zm-8.078 3.821C18.245 27.38 17.167 28 16 28s-2.245-.621-2.83-1.63c-.423-.728.102-1.64.943-1.64h3.774c.841 0 1.366.912.944 1.64z",
    transform: "translate(-1800 -424) translate(1688 424) translate(112)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/bell.fb4a37ee.svg";
export { ForwardRef as ReactComponent };